export default __webpack_public_path__ + "static/media/INEX.5e284ca6.svg";